<template>
  <div class="report__setting">
    <span>Payroll Summaries</span>
    <p>For more details, hover over the check date and click view details.</p>

    <div class="page-loader" v-show="pageLoading">
      <div>
        <PageLoader />
      </div>
    </div>

    <div class="alert d-flex align-items-center" role="alert" v-if="noData">
      <font-awesome-icon icon="times-circle" />
      <p>There are no payroll histories yet.</p>
    </div>

    <div v-show="!pageLoading">
      <div class="report__setting--header">
        <div>Date</div>
        <div>Payroll Type</div>
        <div>Description</div>
        <div></div>
        <div></div>
      </div>
      <div class="report__setting--body">
        <div v-for="(payroll, index) in payrollHistory" :key="index">
          <div>
            {{ formatDate(payroll) }}
            <!-- <span>{{formatDate(payroll)}}</span> -->
            <!-- <p>
              <routerLink
                :to="{ name: 'reportSummary', params: { uuid: payroll.payroll_uuid } }"
              >view details</routerLink>
            </p>-->
          </div>
          <div>Regular</div>
          <div>
            {{payroll.description}}
          </div>
          <div>
            <routerLink
              :to="{
                name: 'reportSummary',
                params: { uuid: payroll.payroll_uuid }
              }"
              >view details</routerLink
            >
          </div>
          <div>
            <div>

            </div>
            <routerLink
              :to="{
                name: 'reportSummary',
                params: { uuid: payroll.payroll_uuid }
              }"
              >
                <img src="../../../assets/images/download.svg" />
                <span>download report</span>
              </routerLink
            >
          </div>
        </div>
      </div>

      <div class="payroll__breakdown--paginate">
        <div @click="paginatePage(pages.first_page_url)">1</div>
        <div @click="paginatePage(pages.prev_page_url)">prev</div>
        <div>{{ pages.current_page }}</div>
        <div @click="paginatePage(pages.next_page_url)">next</div>
        <div @click="paginatePage(pages.last_page_url)">
          {{ pages.last_page }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as types from "../../../store/constant";
import PageLoader from "../../partials/page-loader";
import * as moment from "moment";

export default {
  name: "PayrollHistory",

  components: {
    PageLoader
  },

  data() {
    return {
      pageLoading: true,
      payrollHistory: [],
      dataFetchError: false,
      noData: false,
      pages: {},
      currentPath: ""
    };
  },

  created() {
    this.getPayrollHistory();
  },

  methods: {
    formatDate(payroll) {
      if (payroll.created_at) {
        const date = new Date(payroll.created_at);
        return date.toLocaleString().split(", ")[0];
      }
    },
    setDescription(payrollHistory) {
      for (let index = 0; index < payrollHistory.length; index++) {
        const payment = payrollHistory[index];
        const paymentDate = moment(payment.payment_month, "YYYY-MM-DD");
        payment.description = `${paymentDate.startOf("month").format("DD/MM/YYYY")} - 
        ${paymentDate.endOf("month").format("DD/MM/YYYY")}`;        
      }
    },
    paginatePage(val) {
      if (val) {
        if (val !== this.currentPath) {
          this.pageLoading = true;
          this.payrollHistory = [];
          this.$http
            .get(val)
            .then(resp => {
              this.pages = {
                first_page_url: resp.data.data.first_page_url,
                prev_page_url: resp.data.data.prev_page_url,
                current_page: resp.data.data.current_page,
                next_page_url: resp.data.data.next_page_url,
                last_page_url: resp.data.data.last_page_url,
                last_page: resp.data.data.last_page
              };
              this.currentPath = val;
              this.payrollHistory = resp.data.data.data;

              this.setDescription(this.payrollHistory);

              this.pageLoading = false;

              if (this.payrollHistory.length) return;
              this.noData = true;
            })
            .catch(err => {
              this.pageLoading = false;
              if (err.response) {
                this.dataFetchError = true;
              }
            });
        }
      }
    },

    getPayrollHistory() {
      this.$http
        .get(types.PAYROLL_HISTORY)
        .then(resp => {
          this.pages = {
            first_page_url: resp.data.data.first_page_url,
            prev_page_url: resp.data.data.prev_page_url,
            current_page: resp.data.data.current_page,
            next_page_url: resp.data.data.next_page_url,
            last_page_url: resp.data.data.last_page_url,
            last_page: resp.data.data.last_page
          };
          this.currentPath = this.pages.first_page_url;
          this.payrollHistory = resp.data.data.data;

          this.setDescription(this.payrollHistory);

          this.pageLoading = false;

          if (this.payrollHistory.length) return;
          this.noData = true;
        })
        .catch(err => {
          this.pageLoading = false;
          if (err.response) {
            this.dataFetchError = true;
          }
        });
    },

    formatType(payroll) {
      if (!payroll.type) return;
      return JSON.parse(payroll.type).type;
    }
  }
};
</script>

<style lang="scss" scoped>
.report__setting {
  padding-top: 56px;
  padding-bottom: 150px;

  .alert {
    padding-top: 10px;
    padding-bottom: 30px;
    padding-left: 0;
    font-size: 15px;
    svg {
      margin-right: 7px;
    }
    p {
      margin-bottom: 0;
    }
  }

  .page-loader {
    margin-top: 50px;

    > div {
      width: 55px;
      margin: auto;
    }
  }

  > span {
    font-size: 1.458vw;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.43;
    letter-spacing: normal;
    text-align: left;
    color: #000000;
    font-weight: 600;
  }

  > p {
    font-size: 1.042vw;
    font-weight: 200;
    font-style: normal;
    font-stretch: normal;
    line-height: 2;
    letter-spacing: normal;
    text-align: left;
    margin: 30px 0;
    color: #000000;
  }

  > div {
    > .report__setting--header {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-items: center;
      justify-content: center;
      align-content: center;

      > div {
        width: 25%;
        text-align: center;
        font-size: 1.042vw;
        font-weight: 500;
        font-style: normal;
        font-stretch: normal;
        line-height: 1;
        letter-spacing: normal;
        color: #000000;
        height: 50px;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: center;
        align-content: center;
      }
    }

    > .report__setting--body {
      border-top: 5px solid #5099de;
      margin-bottom: 50px;

      > div {
        height: 60px;
        border-radius: 2px;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
        background-color: #ffffff;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: center;
        align-content: center;
        margin-bottom: 30px;

        > div {
          width: 25%;
          text-align: center;
          font-size: 1.042vw;
          font-weight: 500;
          font-style: normal;
          font-stretch: normal;
          line-height: 1;
          letter-spacing: normal;
          color: #000000;
          // height: 50px;

          > a {
            color: #5099de;
            text-decoration: none;
            
            > img {
              width: 20px;
              height: 20px;
            }

            > span {
              margin-left: 10px;
            }
          }
        }
      }
    }

    > .report__setting--paginate {
      width: 20.833vw;
      margin: auto;
      height: 40px;
      border-radius: 4px;
      box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.05);
      border: solid 1px #d7dae2;
      background-color: #ffffff;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-items: center;
      justify-content: center;
      align-content: center;

      > .report__setting--paginate-prev {
        width: 20%;
        font-size: 0.781vw;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.67;
        letter-spacing: normal;
        text-align: center;
        color: #5099de;
        height: 40px;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: center;
        align-content: center;
        cursor: pointer;
      }

      > .report__setting--paginate-page {
        width: 60%;
        font-size: 0.781vw;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.67;
        letter-spacing: normal;
        text-align: center;
        color: #000;
        height: 40px;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: center;
        align-content: center;
        cursor: pointer;

        > div {
          width: 20%;
          height: 40px;
          border: solid 1px #d7dae2;
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          align-items: center;
          justify-content: center;
          align-content: center;
        }
      }

      > .report__setting--paginate-next {
        width: 20%;
        font-size: 0.781vw;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.67;
        letter-spacing: normal;
        text-align: center;
        color: #000;
        height: 52px;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: center;
        align-content: center;
        cursor: pointer;
      }
    }

    > .payroll__breakdown--paginate {
      width: 300px;
      margin: 50px auto 0 auto;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-items: center;
      justify-content: center;
      align-content: center;
      overflow: hidden;
      border-radius: 4px;
      box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.05);
      border: solid 1px #d7dae2;
      background-color: #ffffff;

      > div {
        width: 20%;
        padding: 8px 0;
        text-align: center;
        font-size: 13px;
        border: solid 1px #d7dae2;
        background-color: #ffffff;
        cursor: pointer;
      }

      > div:nth-child(3) {
        color: #fff;
        background-color: #4F97DC;
        cursor: pointer;
      }
    }
  }
}
</style>
